"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePosition = void 0;
var ImagePosition;
(function (ImagePosition) {
    ImagePosition["LEFT"] = "left";
    ImagePosition["RIGHT"] = "right";
})(ImagePosition = exports.ImagePosition || (exports.ImagePosition = {}));
